import Category from 'modules/AccountsMarketplace/Category/Category'
import Sagas from 'modules/AccountsMarketplace/Category/saga'
import Reducer from 'modules/AccountsMarketplace/Category/reducer'

export { Sagas, Reducer }

export default Category
